<template>
  <p class="form-helper" :class="variant ? 'c-grey-80' : ''">
    <slot />
  </p>
</template>

<script lang="ts" setup>
defineProps<{
  /**
   * Defines variant
   */
  variant?: 'inverse'
}>()
</script>
